import { render } from "./modalCoinPurchaseIAP.vue?vue&type=template&id=7191ea7a&scoped=true"
import script from "./modalCoinPurchaseIAP.vue?vue&type=script&lang=js"
export * from "./modalCoinPurchaseIAP.vue?vue&type=script&lang=js"

import "./modalCoinPurchaseIAP.vue?vue&type=style&index=0&id=7191ea7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7191ea7a"]])

export default __exports__